import {s_char, s_char_matrices} from "../../_signals/s_char";
import Dialog from "@mui/material/Dialog";
import {DialogTitle, ListSubheader} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import React, {useEffect, useState} from "react";
import {ICharMatrice} from "../../_interfaces/ICharMatrice";
import {v4} from "uuid"
import {MatricesCreate} from "../../_api/BEMatrices";
import {matrices} from "../../_helper/matrices";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}

export default function MatriceAdd({open, isOpen}: IProp) {

    const mod_rank = [...Array(16).keys()]

    const availableMatrices = matrices

    const [matrice, setMatrice] = useState<ICharMatrice | null>(null)

    useEffect(() => {
        if (open) {
            const m: ICharMatrice = {
                id: v4(),
                cid: s_char.value.id,
                tid:'',
                name: "",
                rank: 0,
                splittable: false,
                split: false,
                can_hold_threads: false,
                tot: 0,
                note: "",
                free: false,
            };
            if (m) {
                setMatrice(m)
            } else {
                setMatrice(null)
            }
        } else setMatrice(null)
    }, [open])

    const updateRank = (rank: number) => {
        if (matrice) setMatrice({...matrice, rank: rank})
    }

    const updateName = (name: string) => {
        const mat = matrices[name];
        if (matrice) setMatrice({
            ...matrice,
            name: name,
            can_hold_threads: mat.can_hold_thread,
            split: mat.split,
            splittable: mat.splittable,
            tot: mat.tot
        })
    }

    const save = () => {
        if (matrice) {
            let matrices = s_char_matrices.value;
            matrices.push(matrice)
            MatricesCreate(matrice)
            s_char_matrices.value = matrices;
        }
        isOpen(false)
    }

    const cancel = () => {
        isOpen(false)
    }

    return <>{open ? <Dialog open={open}>
            <DialogTitle>{matrice?.name} Erstellen</DialogTitle>
            <DialogContent>
                <Select value={matrice?.name}
                        onChange={(e) => updateName(e.target.value)}
                        variant="standard"
                        name={'name'}
                >
                    {Object.keys(availableMatrices).map(talent => <MenuItem key={v4()}
                                                                            value={talent}>{talent}</MenuItem>)}
                </Select>

                {matrice?.can_hold_threads ?
                    <div style={{fontSize: 'smaller', fontStyle: 'italic', paddingLeft: 8}}>Kann Faden
                        halten</div> : null}
                {matrice?.splittable ?
                    <div style={{fontSize: 'smaller', fontStyle: 'italic', paddingLeft: 8}}>Spaltbar</div> : null}
                {matrice?.tot ?
                    <div style={{fontSize: 'smaller', fontStyle: 'italic', paddingLeft: 8}}>Todesschwelle {matrice?.tot}</div> : null}
                <Select key={v4()}
                        value={matrice?.rank ?? 0}
                        onChange={(e) => updateRank(e.target.value as number)}
                        name={'rank'}
                >
                    <ListSubheader>Kreis</ListSubheader>
                    {mod_rank.map(
                        r => <MenuItem key={v4()} value={r}>{r}</MenuItem>
                    )}
                </Select>
            </DialogContent>
            <DialogActions>
                <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
                <Button className={'btn'} id="post" onClick={() => cancel()}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
        : null}</>
}